import { useTranslation } from 'react-i18next';
import { getCardImagePath } from '../tarot-utils/cardUtils';
import { useCardLocalizer } from '../i18n/useLocalized';
import CardBack from './CardBack';
import './TarotCard.css';

function TarotCard({ card, isRevealed, onClick }) {
  const { t } = useTranslation();
  const localize = useCardLocalizer();
  const shown = localize(card);

  return (
    <div
      className={`tarot-card ${isRevealed ? 'flipped' : ''}`}
      onClick={onClick}
    >
      <div className="card-inner">
        <div className="card-front">
          <CardBack />
          <span className="offscreen">{t('deck.cardBack')}</span>
        </div>
        <div className="card-back-face">
          <img
            src={getCardImagePath(card.filename)}
            alt={shown.name}
            className="card-image"
            loading="lazy"
            decoding="async"
          />
        </div>
      </div>
    </div>
  );
}

export default TarotCard;
